import { Avatar, Box, Button, Container, Divider, Fab, Grid, IconButton, List, ListItem, ListItemAvatar, ListItemText, Paper, Typography, styled } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import MenuIcon from '@mui/icons-material/Menu';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import React from 'react';
import { useAppContextoReact } from '../../../src/servicos/app/AppContextoReact';
import { useNavigate } from 'react-router-dom';

const Home = () =>
{
	const appContext = useAppContextoReact();

	const [userRoleAdmin, setUserRolerAdmin] = React.useState<boolean|null|undefined>(null);

	const navigate = useNavigate();

	React.useEffect(() =>
	{
		const isAdmin = appContext.permissao.administrador
		setUserRolerAdmin(isAdmin)
		!isAdmin ? navigate('/lista-programas') : ''
	},[appContext])
	return <>
		<Container>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<Typography component={'span'} variant={'h1'}>Bem-vindo ao MVP do novo projeto <b>Acervo Digital</b></Typography>
				</Grid>
				<Grid item xs={12}>
					<Paper variant='outlined' sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
						<Grid item xs={12}>
							<Typography>Dicas úteis para uso do sistema:</Typography>
						</Grid>
						<Grid item xs={12}>
							<List>
      						<StyledListItem>
        							<ListItemText
										primary="Menu"
										secondary={
											<React.Fragment>
												{"O menu localiza-se à sua esquerda e pode ser contraído ("}
												<IconButton size="small" title="Contrair menu" aria-label="Contrair menu"><ChevronLeftIcon/></IconButton>
												{") ou expandido ("}
												<IconButton size="small" title="Expandir menu" aria-label="Expandir menu"><MenuIcon/></IconButton>
												{") através dos ícones localizados no canto superior esquerdo da tela."}
											</React.Fragment>}
									/>
								</StyledListItem>

								<StyleDivider/>
      						<StyledListItem>
									<ListItemText
										primary="Botão Adicionar"
										secondary={<React.Fragment>{"O botão Adicionar encontra-se imediatamente acima das listas dos cadastros, à direita do título da página. Ao clicá-lo, dependendo da funcionalidade, será aberta uma nova janela ou um lightbox para criação de um novo item."}</React.Fragment>}
									/>
									<StyledListItemAvatar>
										<Fab color="primary" size="small" variant="circular" title="Novo item" aria-label="Adicionar"><AddIcon/></Fab>
									</StyledListItemAvatar>
								</StyledListItem>

								<StyleDivider/>
      						<StyledListItem>
									<ListItemText
										primary="Botão Filtrar"
										secondary={<React.Fragment>{"O botão Filtrar, presente em alguns cadastros, encontra-se imediatamente acima das listas, à direita do título da página. Ao clicá-lo, a área de filtros é aberta à direita onde é possível fazer o preenchimento dos filtros desejados."}</React.Fragment>}
									/>
									<StyledListItemAvatar>
										<Fab color="primary" size="small" variant="circular" title="Filtrar" aria-label="Filtrar"><FilterAltOutlinedIcon/></Fab>
									</StyledListItemAvatar>
								</StyledListItem>

								<StyleDivider/>
      						<StyledListItem>
									<ListItemText
										primary="Botão Editar"
										secondary={<React.Fragment>{"O botão Editar encontra-se em cada linha das listas dos cadastros. Ao clicá-lo, dependendo da funcionalidade, será aberta uma nova janela ou um lightbox para edição do item selecionado."}</React.Fragment>}
									/>
									<StyledListItemAvatar>
										<IconButton size="medium" color="primary" title="Editar item" aria-label="Editar"><EditIcon/></IconButton>
									</StyledListItemAvatar>
								</StyledListItem>

								<StyleDivider/>
      						<StyledListItem>
									<ListItemText
										primary="Botão Excluir"
										secondary={<React.Fragment>{"O botão Excluir encontra-se em cada linha das listas dos cadastros. Ao clicá-lo, o usuário deverá confirmar a exclusão do item selecionado."}</React.Fragment>}
									/>
									<StyledListItemAvatar>
										<IconButton size="medium" color="error" title="Excluir item" aria-label="Excluir"><DeleteIcon/></IconButton>
									</StyledListItemAvatar>
								</StyledListItem>

								<StyleDivider/>
      						<StyledListItem>
        							<ListItemText
										primary="Formulários de adicionar e editar"
										// secondary={<React.Fragment>{"Todos os formulários, com exceção de programa, são abertos em um lightbox. Adicionar e editar programa abrem sempre uma nova janela devido à quantidade de campos e, desta forma, peso do formulário."}</React.Fragment>}
										secondary={<React.Fragment>{"Todos os formulários são abertos em um lightbox a partir da sua lista."}</React.Fragment>}
									/>
								</StyledListItem>

								<StyleDivider/>
      						<StyledListItem>
									<ListItemText
										primary="Botão Salvar"
										secondary={<React.Fragment>{"O botão Salvar encontra-se no final dos formulários de cadastro."}</React.Fragment>}
									/>
									<StyledListItemAvatar>
										<Box display='flex' flexWrap={'wrap'} flexDirection={"column"} alignItems={'center'}>
											<Button sx={{wdth:"10rem"}}  color="primary" size="small" variant="contained" startIcon={<SaveOutlinedIcon/>}>Salvar</Button>
										</Box>
									</StyledListItemAvatar>
								</StyledListItem>

								{ /*
								<StyleDivider/>
      						<StyledListItem>
									<ListItemText
										primary="Botão Salvar alternativo"
										secondary={<React.Fragment>{"No formulário de Programa, pelo fato de não ser uma janela em lightbox, há também um segundo botão Salvar localizado imediatamente abaixo do título da página."}</React.Fragment>}
									/>
									<StyledListItemAvatar>
										<Box display='flex' flexWrap={'wrap'} flexDirection={"column"} alignItems={'center'}>
											<Fab color="primary" size="small" variant="circular" title="Salvar" aria-label="Salvar"><SaveOutlinedIcon/></Fab>
										</Box>
									</StyledListItemAvatar>
								</StyledListItem>
								*/ }
							</List>
						</Grid>
					</Paper>
				</Grid>
			</Grid>
		</Container>
	</>
}
export default Home;
const StyledListItem = styled(ListItem)(({ theme }) => ({
	alignItems: "center",
	justifyContent: "space-between",
	paddingLeft: "0.5rem",
	paddingRight: "0.5rem",
	"& button": {
		"& .MuiFab-root": {
			width: "2.5rem",
			height: "2.5rem",
		},
		minHeight: 0,
	}
}));
const StyledListItemAvatar = styled(ListItemAvatar)(({ theme }) => ({
	minWidth: "3rem",
//	width: "3rem",
	textAlign: "center"
 }));
const StyleDivider = styled(Divider)(({ theme }) => ({
	marginLeft: "0.5rem",
	marginRight: "4rem",
}));